import React from 'react'

export const Footer = () => {
  return (
    <div className='_footer '>

        <div className='container  boxs'>

            <div className='col-12 col-sm-3 col-lg-3 text-center iconsContainer'>
                Medios de contacto

                <div className=' icons'>


                  

                        <a 
                            href="https://www.facebook.com/ZapataEzequiel/" 
                            target="_blank" 
                            className='contact'> 
                                <img 
                                    src=" https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/2021_Facebook_icon.svg/640px-2021_Facebook_icon.svg.png "
                                    alt="" 
                                />
                        </a>
                    
                

                        <a 
                            href="https://steamcommunity.com/id/Eche14/" 
                            target="_blank" 
                            className='contact'> 
                                <img 
                                    src=" https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Steam_icon_logo.svg/2048px-Steam_icon_logo.svg.png"
                                    alt="" 
                                />
                        </a>
                    
                        <a className="contact" 
                            href="mailto:zapata.ed1989@gmail.com?subject=Echestore" 
                            target="_blank" 
                            rel="noreferrer"
                            ><img src="https://es.seaicons.com/wp-content/uploads/2015/11/03-Mail-icon.png" alt="" />
                        </a>

                   
                </div>

            </div>
            <div className='col-12 col-sm-8 col-lg-6 text-center iconsContainer'>
                Medios de pago

                <div className='row icons'>   
                    
                        <img src="https://cdn-icons-png.flaticon.com/512/3898/3898067.png" alt="" />
                        <img src="https://seeklogo.com/images/M/mercado-pago-logo-52B7182205-seeklogo.com.png" alt="" />
                        <img src="https://seeklogo.com/images/U/uala-logo-7959775EA9-seeklogo.com.png" alt="" />
                        <img src="https://paganresearch.io/images/brubank.png" alt="" />

                  
                        {/* <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png" alt="" /> */}
                        {/* <img src="https://callmekate.es/wp-content/uploads/2021/08/2560px-MasterCard_Logo.svg.png" alt="" /> */}
                        <img src="https://sameep.gob.ar/wp-content/uploads/2019/06/rapipago2.png" alt="" />
                        <img src="https://seeklogo.com/images/P/pago-facil-2019-logo-8BE6DD28D6-seeklogo.com.png" alt="" />

                

                </div>

            </div>
            <div className='col-12 col-lg-3 desarrollo text-center '>
            
                Desarrollado por <a href="http://www.ezequiel-zapata.online/" target="_blank" className='ref'>Ezequiel Zapata</a>  ©Todos los derechos reservados
            </div>

        </div>
        
        
        
        
    </div>
  )
}
